module.exports = "https://wrf-static.prod-my.games/promo/long-lp/img/page-about-video-bg.235225b8.webp";